<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    max-width="500px"
    v-if="id && user"
  >
    <v-card>
      <v-card-title>
        <span class="headline">
          <avatar :user="user" />{{ user.Profile && user.Profile.Name }}
        </span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <!-- 個人資料 -->
            <v-col
              v-if="userLevel <= 10"
              cols="12"
              sm="12"
              md="12"
            >

              <v-list dense>
                <v-list-item>
                  <v-list-item-content>帳號:</v-list-item-content>
                  <v-list-item-content class="align-end">{{ user.Username }}</v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>部門:</v-list-item-content>
                  <v-list-item-content class="align-end">{{ userDepartment.Name }}</v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>職稱:</v-list-item-content>
                  <v-list-item-content class="align-end">{{ userPosition }}</v-list-item-content>
                </v-list-item>
              </v-list>

            </v-col>

            <!-- 薪資 -->
            <v-col
              v-if="userLevel <= 10"
              cols="12"
              sm="12"
              md="12"
            >

              <v-list dense>
                <v-list-item>
                  <v-list-item-content>底薪:</v-list-item-content>
                  <v-list-item-content class="align-end">{{ userSalary.Amount }}</v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>勞健保-員工自付額:</v-list-item-content>
                  <v-list-item-content class="align-end">{{ userSalary.Insurance }}</v-list-item-content>
                </v-list-item>
              </v-list>

            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          @click="close"
        >關閉</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import Avatar from "@/ui/components/avatar.vue";
import AppDataSetting from '@/data/app-data-setting.js'
export default {
  components: { Avatar },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    id: {
      type: Number
    }
  },
  data: () => ({}),
  computed: {
    user() {
      return this.users.find(o => o.ID == this.id);
    },
    userDepartmentID() {
      const findUserDepartmentID = user =>
        (this.userDepartments.find(o => o.UserID == user.ID) || {})
          .DepartmentID;
      return findUserDepartmentID(this.user);
    },
    userDepartment() {
      if (!this.userDepartmentID) return {};
      return this.departments.find(o => o.ID == this.userDepartmentID);
    },
    userLevel() {
      let level = AppDataSetting.findUserLevel(this, this.user);
      return level;
    },
    userPosition() {
      let level = this.userLevel;

      if (level === 1) return "員工";
      if (level === 10) return "主管";
      if (level === 100) return "會計";
      if (level === 1000) return "總經理";
      if (level === 10000) return "蝦董";
      if (level === 100000) return "工程師";
      return level;
    },
    userSalary() {
      const findUserSalary = user =>
        this.userSalaries.find(o => o.UserID == user.ID);
      return findUserSalary(this.user);
    },
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    ...mapGetters([
      "departments",
      "userPositions",
      "userSalaries",
      "userDepartments",
      "users"
    ])
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>